import { ApolloLink, concat, ApolloClient, InMemoryCache, defaultDataIdFromObject } from '@apollo/client';
import inflate from './inflate';
import link from './link';

const inflateLink = new ApolloLink((operation, forward) => {
  operation.setContext({ start: new Date() });
  return forward(operation).map(response => {
    return inflate(response);
  });
});

const client = new ApolloClient({
  link: concat(inflateLink, link),
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      return defaultDataIdFromObject(object) || JSON.stringify(object);
    },
  }),
});

export default client;
